<template>
    <div class="financial">
      <financial-container></financial-container>
    </div>
</template>
<script>
import FinancialContainer from '@/components/financial/Container.vue'
export default {
  name: 'financial',
  components: {
    FinancialContainer
  }
}
</script>
<style lang="stylus">
.financial
  height 100%
</style>
